import { render, staticRenderFns } from "./iw.vue?vue&type=template&id=942e4c08&"
import script from "./iw.vue?vue&type=script&lang=js&"
export * from "./iw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports